import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import CartPanel from './components/CartPanel'

import Navigation from './components/navigation'
import Footer from './components/footer'

import HomeSection from './sections/HomeSection'
import FriterieSection from './sections/FriterieSection'
import PatrimoineSection from './sections/PatrimoineSection'
import { CartProvider } from './context/CartContext'
import { AnnouncementProvider } from './context/AnnouncementContext'
import AdminMenuSection from './sections/AdminMenuSection'
import { useMenuApi } from './hooks/useMenuApi'
import './style.css'

const App = () => {
  const { menu } = useMenuApi({
    load: true,
    withAuth: false
  })

  const [showHoursTooltip, setShowHoursTooltip] = React.useState(false)

  const toggleHoursTooltip = () => {
    setShowHoursTooltip(v => !v)
  }

  return (
    <>
      <Navigation
        menu={menu}
        showHoursTooltip={showHoursTooltip}
        setShowHoursTooltip={setShowHoursTooltip}
        toggleHoursTooltip={toggleHoursTooltip}
      />

      <CartPanel
        menu={menu}
        onOpenHours={toggleHoursTooltip}
      />

      <main>
        <Switch>
          <Route exact path="/" component={HomeSection} />
          <Route path="/menu" component={FriterieSection} />
          <Route path="/patrimoine" component={PatrimoineSection} />
          <Route path="/admin" component={AdminMenuSection} />
        </Switch>
      </main>

      <Footer menu={menu}
       />
    </>
  )
}
ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <CartProvider>
          <AnnouncementProvider>
            <App />
          </AnnouncementProvider>
        </CartProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
) 